module.exports = __webpack_public_path__ + "img/s1-2.01e55802.jpg";